import { useState, type FormEvent } from 'react';
import { api } from '../api';
import { useAuth } from '../auth';
import { Button, ErrorBox, Field, inputCls } from '../components/ui';

/** Troca obrigatória da senha temporária (1º acesso ou senha redefinida). */
export function ChangePassword() {
  const { me, refresh, logout } = useAuth();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (next !== confirm) return setError('A confirmação não confere com a nova senha.');
    setBusy(true);
    setError(null);
    try {
      await api('/api/auth/change-password', { method: 'POST', body: { current, next } });
      await refresh();
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-brand-950 p-4">
      <form onSubmit={submit} className="w-full max-w-sm space-y-4 rounded-lg bg-white p-6 shadow-xl" aria-labelledby="pw-title">
        <img src="/brand/3s-logo.svg" alt="3S Networks" className="h-16 w-auto" />
        <div>
          <h1 id="pw-title" className="text-xl font-semibold text-brand-900">
            Defina sua senha
          </h1>
          <p className="mt-1 text-sm text-slate-600">
            Olá, {me?.user.name}. Você entrou com uma senha temporária. Crie uma senha própria com pelo menos 12 caracteres, letras e números.
          </p>
        </div>
        <ErrorBox error={error} />
        <Field label="Senha temporária" required>
          <input className={inputCls} type="password" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} required />
        </Field>
        <Field label="Nova senha" required>
          <input className={inputCls} type="password" autoComplete="new-password" minLength={12} value={next} onChange={(e) => setNext(e.target.value)} required />
        </Field>
        <Field label="Confirme a nova senha" required>
          <input className={inputCls} type="password" autoComplete="new-password" minLength={12} value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
        </Field>
        <div className="flex gap-2">
          <Button type="submit" disabled={busy}>
            {busy ? 'Salvando…' : 'Salvar senha'}
          </Button>
          <Button variant="secondary" onClick={() => void logout()}>
            Sair
          </Button>
        </div>
      </form>
    </div>
  );
}
